import React, { useState } from "react";
import Grid from "styled-components-grid";
import Input from "../UI/Form/Input";
import styled from "styled-components";
import SelectUI from "../UI/Form/SelectUI";
import Category from "./Category";
import { AiOutlineCloudUpload } from "react-icons/ai";

const Swatch = styled.div`
  width: 50px;
  height: 30px;
  border: 1px solid grey;
  border-radius: 3px;
  margin: 0.5em;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
`;
const ColourContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;
export default function CompetitionEdit({ competition, onChange }) {
  function updateCompetition(competition) {
    onChange(competition);
  }

  return (
    <Grid style={{ width: "100%" }}>
      <Grid.Unit size={1 / 1}>
        <Input
          value={competition.name}
          title="Name"
          onChange={(e) => {
            let newCompetition = { ...competition, name: e.target.value };
            updateCompetition(newCompetition);
          }}
        />
        <Input
          value={competition.country}
          title="Country"
          onChange={(e) => {
            let newCompetition = { ...competition, country: e.target.value };
            updateCompetition(newCompetition);
          }}
        />
        <Input
          value={competition.order}
          title="Order"
          onChange={(e) => {
            let newCompetition = { ...competition, order: e.target.value };
            updateCompetition(newCompetition);
          }}
        />

        <Input
          value={competition.order}
          title="Flag viz path (IMAGE*/PFL2023/_Globals/ScoreboardFlags/)"
          onChange={(e) => {
            let newCompetition = { ...competition, flag_path: e.target.value };
            updateCompetition(newCompetition);
          }}
        />

        <Input
          value={competition.order}
          title="Fighter viz path (IMAGE*/PFL2023/_Globals/)"
          onChange={(e) => {
            let newCompetition = {
              ...competition,
              fighter_path: e.target.value,
            };
            updateCompetition(newCompetition);
          }}
        />

        <Input
          value={competition.order}
          title="Full Fighter viz path (IMAGE*/PFL2023/_Globals/Fighter_Full/)"
          onChange={(e) => {
            let newCompetition = {
              ...competition,
              fighter_full_path: e.target.value,
            };
            updateCompetition(newCompetition);
          }}
        />

        <FileUpload
          id="badge"
          label="Badge"
          value={competition?.badge || ""}
          onChange={(filename) => {
            let newCompetition = { ...competition, badge: filename };
            updateCompetition(newCompetition);
          }}
        />

        <FileUpload
          id="secondaryBadge"
          label="Secondary Badge"
          value={competition?.secondary_badge || ""}
          onChange={(filename) => {
            let newCompetition = { ...competition, secondary_badge: filename };
            updateCompetition(newCompetition);
          }}
        />

        <SelectUI
          title="Competition Type"
          value={
            competition?.competition_type
              ? {
                  value: competition.competition_type,
                  label: competition.competition_type,
                }
              : ""
          }
          options={[
            {
              value: "bellator",
              label: "bellator",
            },
            {
              value: "pfl europe",
              label: "pfl europe",
            },
            {
              value: "Total Kombat",
              label: "Total Kombat",
            },
            {
              value: "Sky Boxing",
              label: "Sky Boxing",
            }
          ]}
          placeholder="Select format..."
          onChange={(value) => {
            const selectedValue = value;
            let defaultCategories = [];
            if (selectedValue === "bellator" || selectedValue === "pfl europe") {
              defaultCategories = [
                "Arm Strikes", "Arm Strikes Landed", "Arm Strikes Missed",
                "Leg Strikes", "Leg Strikes Landed", "Leg Strikes Missed",
                "Ground Strikes", "Ground Strikes Landed", "Ground Strikes Missed",
                "Submissions Attempted", "Submissions Landed", "Submissions Missed",
                "Takedowns", "Takedowns Landed", "Takedowns Missed",
              ];
            } else if (selectedValue === "Total Kombat") {
              defaultCategories = [
                "Arm Strikes", "Arm Strikes Landed", "Arm Strikes Missed",
                "Leg Strikes", "Leg Strikes Landed", "Leg Strikes Missed",
                "Ground Strikes", "Ground Strikes Landed", "Ground Strikes Missed",
                "Takedowns", "Takedowns Landed", "Takedowns Missed",
                "Jump Kicks", "Jump Kicks Landed", "Jump Kicks Missed",
                "Head Kicks", "Head Kicks Landed", "Head Kicks Missed",
              ];
            } else if (selectedValue === "Sky Boxing") {
              defaultCategories = [
                "Head Shots", "Head Shots Landed", "Head Shots Missed",
                "Body Shots", "Body Shots Landed", "Body Shots Missed",
                "Jabs", "Jabs Landed", "Jabs Missed",
                "Power Shots", "Power Shots Landed", "Power Shots Missed",
              ];
            }
            let newCompetition = { ...competition, competition_type: value, categories: defaultCategories };
            updateCompetition(newCompetition);
          }}
        />
        <Category competition={competition} updateCompetition={updateCompetition} />
      </Grid.Unit>
    </Grid>
  );
}

function FileUpload({ value, onChange, label, id }) {
  const [open, setOpen] = useState(false);
  const userId = localStorage.getItem("user-id");
  const project_serevr_url =
    window.ENV?.REACT_APP_PROJECT_SERVER ||
    process.env.REACT_APP_PROJECT_SERVER;

  function handleClose() {
    setOpen(false);
  }

  function upload(e) {
    const files = Array.from(e.target.files);

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append("file", file);
    });

    fetch(`${project_serevr_url}/api/assets/images/${userId}`, {
      method: "POST",
      body: formData,
    }).then((data) => {
      onChange(files[0].name.replace(/ /g, "_"));
    });
  }
  return (
    <ColourContainer>
      <Input
        value={value}
        title={label}
        onChange={(e) => {
          onChange(e.currentTarget.value);
        }}
      />
      <input
        id={id}
        type="file"
        name="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          upload(e);
        }}
      />
      <div>
        <Swatch
          style={{
            backgroundColor: value,
          }}
          onClick={() => document.getElementById(id).click()}
        >
          {!value && <AiOutlineCloudUpload />}
          {value && (
            <img
              style={{ objectFit: "contain", width: "50px", height: "30px" }}
              src={
                project_serevr_url +
                "/api/assets/images/" +
                userId +
                "/" +
                value
              }
              alt="Competition Badge"
            />
          )}
        </Swatch>
      </div>
    </ColourContainer>
  );
}
